import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { isDevMode } from '@angular/core';
import { ThumbSettings } from '@syncfusion/ej2-angular-charts';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.css'],
    standalone: false
})
export class ErrorComponent implements OnInit {

  userMessage: string;
  errorCode: string;
  iconClass: string;
  devMode = false;
  devMessage = '';
  title = '';
  pageNotFound = false;

  // Constructor
  constructor (private activatedRoute: ActivatedRoute, private appGlobals: AppGlobals) {
  }

  ngOnInit(): void {

    this.devMode = isDevMode();

    // Dev Mode message. Not visible in the Production
    this.devMessage = this.activatedRoute.snapshot.paramMap.get('message');
    this.errorCode = this.activatedRoute.snapshot.paramMap.get('code');

    // if undefined route is used give a 404
    if (!this.devMessage && !this.errorCode) {
      this.errorCode = '404';
      this.pageNotFound = true;
    }

    // error messages are intended to be user friendly, the ones that are for the Prod mode.
    switch (this.errorCode) {
      case this.appGlobals.ERROR_CODE_FORBIDDEN:
        this.userMessage = this.appGlobals.FORBIDDEN_ERROR_MESSAGE;
        this.iconClass = 'fal fa-ban';
        this.title = 'Forbidden'
        break;

      case this.appGlobals.ERROR_CODE_NOT_FOUND:

        if (this.pageNotFound) {
          this.userMessage = this.appGlobals.PAGE_NOT_FOUND;
          this.iconClass = 'fal fa-user-magnifying-glass';
          this.title = 'Page Not Found';
          this.devMessage = '404 - incorrect route'
        } else {
          this.userMessage = this.appGlobals.NOT_FOUND_ERROR_MESSAGE;
          this.iconClass = 'fal fa-user-magnifying-glass';
          this.title = 'Resource Not Found'
        }

        break;

      case this.appGlobals.ERROR_CODE_UNAUTHORIZED:
        this.userMessage = this.appGlobals.NOT_AUTHORIZED_ERROR_MESSAGE;
        this.iconClass = 'fal fa-user-lock';
        this.title = 'Unauthorized';
        break;

      case this.appGlobals.ERROR_CODE_GENERIC_ERROR:
        this.userMessage = this.appGlobals.GENERIC_HTTP_ERROR_MESSAGE;
        this.iconClass = 'fal fa-cloud-exclamation';
        this.title = 'Server Error';
        break;
      default:
        this.userMessage = this.appGlobals.GENERIC_HTTP_ERROR_MESSAGE;
        this.title = 'Unexpected Error';
        this.iconClass = 'fal fa-cloud-exclamation';
        break;
    }
  }

  // Sets the message to display
  setMessage(message: string) {
    this.userMessage = message;
  }
}
